import {Usuario} from "@/models/user.interface";
import {URL_API} from "@/config/utils"
import axios from "axios";
import {attemptLogin} from "@/models/up.interface";

export class UserService{

   store(user:Usuario){
    if (user!=null){
       localStorage.setItem("usuario",JSON.stringify(user));
    }
  }//finde store

   fetch():Usuario{
    return JSON.parse( localStorage.getItem("usuario"));
  }
   clean(){
     localStorage.removeItem("usuario");
  }

  async loginUploader(obj:attemptLogin){
    try{
	const resp=await axios.post(`${URL_API}login-uploader`,obj);
	let response= resp.status;
	console.log(resp.data.response);
	if(response ==202){return resp.data.response;}
    }catch(exception){return false}
    return false;
  }
  
}//fin de clase 
